<template>
    <div class="popup popup-rule" id="guestPassportModal" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  style="display: block;">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>补全护照信息</p>
            <a class="shorexDetail-returnButton" @click="onGoBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="ruleDetail">
            <div class="modify scroll-container js-smartScroll">
                <div class="modify-box">
                    <div class="modify-cell">
                        <div class="modify-cell-title modify-cell-title2">护照号</div>
                        <div class="modify-cell-inputBox">
                            <input placeholder="必填，必须与护照一致" v-model="passPortNum" data-key="PassPortNum" @focus="txtFocus" @input="passPortNumInput" type="text" class="js-hasClose" id="modifyPassport">
                        </div>
                        <div class="modify-cell-close">
                            <img class="input-clear" src="https://resource.rcclchina.com.cn/bookingPay/icon12.png">
                        </div>
                    </div>

                    <div class="modify-cell">
                        <div class="modify-cell-title modify-cell-title2">有效期至</div>
                        <div class="modify-cell-inputBox">
                            <input placeholder="必填，必须与护照一致" data-key="PassPortExpirationDate" @change="passPortExpirationDateChanged($event.target.value)"
                            :value="passPortExpirationDate"  ref="passport" id="passportValidity">
                        </div>
                        <div class="modify-cell-icon">
                            <img src="https://resource.rcclchina.com.cn/bookingPay/icon21.png">
                        </div>
                    </div>

                </div>

                <div class="modify-btn" @click="updateGuestPassport">保 存</div>
            </div>
        </div>

    </div>
</template>

<script>
import api from '@/api'
import Picker from 'pickerjs'
import 'pickerjs/dist/picker.min.css'
export default {
    name: "GuestPassportPopup",
    props: {
        isShow: {
            type: Boolean
        },
        onGoBack: {
            type: Function
        },
        onGuestPassportChange: {
            type: Function
        },
        guest: {
            type: Object,
            default () {
                return {
                    chineseLastName: "",
                    chineseFirstName: "",
                    pinYinLastName: "",
                    pinYinFirstName: "",
                    id: 0,
                    passPortNum: "",
                    passPortExpirationDate: ""
                }
            }
        },
    },
    data () {
        return {
            passPortNum: "",
            passPortExpirationDate: "",
            originalPassPortNum: '',
            originalPassPortExpirationDate: '',
            isShowModal: false,
            isMaskValue: true,
            isPassPortExpirationDateChanged: false,
            updateFields: [],
            isPassPortNumInput: false
        }
    },
    mounted () {
        // this.passPortNum = this.guest.passPortNum
        // if (this.guest.passPortExpirationDate && this.guest.passPortExpirationDate.length > 0) {
        //     if (this.guest.passPortExpirationDate.length > 10) {
        //         this.passPortExpirationDate = this.originalPassPortExpirationDate = this.guest.passPortExpirationDate.substring(0, 10)
        //     } else {
        //         this.passPortExpirationDate = this.originalPassPortExpirationDate = this.guest.passPortExpirationDate
        //     }
        // }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        },
        passPortExpirationDateChanged(date) {
          if(date) {
            this.passPortExpirationDate = date
            if(!this.updateFields.includes("PassPortExpirationDate")) {
              this.updateFields.push('PassPortExpirationDate');
            }
          }
        },
        async updateGuestPassport() {
          if (this.updateFields.length === 0) {
            this.$alert.show('没有任何修改');
            return false
          }

          if (!this.isMaskValue || this.updateFields.includes("PassPortNum")) {
            if (!this.passPortNum || this.passPortNum.length == 0) {
              this.$alert.show("请输入正确的护照号");
              return
            }
          }

          if (!this.isMaskValue || this.updateFields.includes("PassPortExpirationDate")) {
            if (!this.passPortExpirationDate || this.passPortExpirationDate.length == 0) {
              this.$alert.show("请填写护照有效期");
              return
            }
          }

          const request = {
            id: this.guest.id,
            passPortNum: this.passPortNum,
            passPortExpirationDate: this.passPortExpirationDate,
            updateFields: this.updateFields
          }

          this.$loading.show()
          const {success, errMsg} = await api.booking.updateBookingGuest(request)
          this.$loading.hide()
          if (!success) {
            if (errMsg && errMsg.length > 0) {
              this.$alert.show(errMsg)
            }
          } else {
            this.$alert.show("修改成功")
            this.onGuestPassportChange(request)
          }
        },
        txtFocus(e) {
          let dataKey = e.target.getAttribute('data-key')
          if (this.isMaskValue) {
            if(dataKey === 'PassPortNum' && !this.isPassPortNumInput) {
              this.passPortNum = '';
            }
          }
          if(!this.updateFields.includes("PassPortNum")) {
            this.updateFields.push('PassPortNum');
          }
        },
        passPortNumInput() {
          this.isPassPortNumInput = true;
        }
    },
    watch: {
        isShow (newValue) {
          setTimeout(()=> {
            this.isShowModal = newValue;
            this.isMaskValue = this.$store.state.page.isMaskValue;
          }, 100)
        },
        guest (newValue) {
            this.passPortNum = this.originalPassPortNum = newValue.passPortNum
            let passPortExpirationDate = "";
            if (this.guest.passPortExpirationDate && newValue.passPortExpirationDate.length > 0) {
                if (this.guest.passPortExpirationDate.length > 10) {
                  passPortExpirationDate = this.originalPassPortExpirationDate = newValue.passPortExpirationDate.substring(0, 10);
                  this.passPortExpirationDate = this.isMaskValue ? newValue.passPortExpirationDateStr : passPortExpirationDate;
                } else {
                  passPortExpirationDate = this.originalPassPortExpirationDate = newValue.passPortExpirationDate;
                  this.passPortExpirationDate = this.isMaskValue ? newValue.passPortExpirationDateStr : passPortExpirationDate;
                }
            }

            let date = passPortExpirationDate&&passPortExpirationDate.length>0?
                new Date(passPortExpirationDate): new Date()
            new Picker(this.$refs.passport, {
                format: 'YYYY-MM-DD',
                date: date,
                text: {
                    title: '请选择护照有效期(年/月/日)',
                    cancel: '取消',
                    confirm: '确认',
                },
            })
        }
    }
}
</script>

<style lang="less" scoped>
#guestPassportModal.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
    z-index: 10401;
}
#guestPassportModal.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#guestPassportModal.modal-out {
    transform: translate3d(100%, 0, 0);
}

#guestPassportModal {
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            img {
                width: 33%;
            }
        }
    }
    .ruleDetail {
        padding-top: 50px;
        height: 100%;
        overflow: scroll;
        padding-bottom: 60px;
    }


    .modify {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        overflow-y: auto;
        padding-top: 10px;
    }
    .modify img {
        max-width: 100%;
    }
    .modify input,
    .modify select {
        -webkit-appearance: none;
        outline: none;
        border: none;
        border-radius: 0;
        padding: 0;
        background-color:transparent;
    }

    .modify-box {
        margin-bottom: 10px;
        padding: 9px 20px 83px;
        background-color: #fff;
    }
    .modify-cell {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        height: 45px;
        border-bottom: 1px solid #E5E5E5;
    }
    .modify-cell-title {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
            -ms-flex: none;
                flex: none;
        width: 82px;
        font-size: 14px;
        line-height: 20px;
        color: #333;
    }
    .modify-cell-title2 {
        width: 90px;
    }
    .modify-cell-inputBox {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
    }
    .modify-cell-inputBox input {
        width: 100%;
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #333;
    }
    .modify-cell-close {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
            -ms-flex: none;
                flex: none;
        width: 15px;
        margin-left: 10px;
    }
    .input-clear {
        display: none;
        width: 15px;
        height: 15px;
    }

    .modify-cell-txt {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
            -ms-flex: none;
                flex: none;
        margin-left: 10px;
        font-size: 12px;
        line-height: 16px;
        color: #666;
    }
    .modify-cell-imgCode {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
            -ms-flex: none;
                flex: none;
        width: 60px;
        height: 22px;
        margin-left: 10px;
    }
    .modify-cell-imgCode img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .modify-cell-icon {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
            -ms-flex: none;
                flex: none;
        margin-left: 10px;
    }
    .modify-cell-icon img {
        display: block;
        width: 20px;
    }


    .modify-tip {
        display: flex;
        padding: 4px 20px 13px;
    }
    .modify-tip-icon {
        display: block;
        width: 12px;
        height: 12px;
        margin-top: 2px;
        margin-right: 4px;
    }
    .modify-tip-txt {
        font-size: 12px;
        line-height: 16px;
        color: #FF5055;
    }


    .modify-btn {
        width: 100%;
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        color: #454545;
        text-align: center;
        background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
        background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
        background: -moz-linear-gradient(left, #FEBC10, #FAD961);
        background: -o-linear-gradient(left, #FEBC10, #FAD961);
        background: linear-gradient(to right, #FEBC10, #FAD961);
    }



}
</style>

<style lang="less">
#guestPassportModal .rule-item .rule-item-text p {
    margin: 0px;
}
</style>
